<section class="dashboard">
    <ng-container *ngIf="contract$ | async as contract">
        <!-- <edp-header-contract *ngIf="!isApp" class="d-none"></edp-header-contract> -->
        <dashboard-header-es></dashboard-header-es>
        <edp-dashboard-simple-grid></edp-dashboard-simple-grid>
    </ng-container>
</section>